import React, { Component } from 'react'
import DragDropFunctions from '~/utils/TemplateEditor/dragDropFunctions'
import clone from 'lodash/clone'
import Redactor from '~/Common-Objects/RedactorSwitch'
export default class DivEditable extends Component {
    constructor(props) {
        super(props)

        this.updateHtmlValue = this.updateHtmlValue.bind(this)
    }

    updateHtmlValue(value) {
        var newObject = clone(this.props.elementData)
        newObject.content.value = value
        this.props.updateElement(newObject, this.props.path)
    }

    render() {
        var eleProps
        if (this.props.elementData.props) {
            eleProps = DragDropFunctions.generatePropsForStage(
                this.props.elementData.props,
                this.props.globalVariables,
                'div',
                this.props.localVariables
            )
        }

        if (!this.props.elementData.content) {
            return <span {...eleProps}>{this.props.children}</span>
        }

        var thisContent = this.props.elementData.content.value || ''
        if (typeof thisContent !== 'string') thisContent = String(thisContent)
        if (thisContent.indexOf('_localVariables_') >= 0) {
            thisContent = DragDropFunctions.lookupLocalVariables(this.props.localVariables, thisContent) || ''
        }

        const isSelected = this.props.selectedElement.path === this.props.currentParentPath
        const hasLabel = Boolean(thisContent)
        let redactorEle = null
        if (
            isSelected &&
            this.props.elementData?.content?.editableInline &&
            this.props.elementData?.content?.editable
        ) {
            const elementUuid = this.props?.tuuid?.tuuid || ''
            const favoriteColors = this.props.elementsData.globalVariables.favoriteColors || []
            const color = eleProps?.style?.color || null
            const noOuterDiv = this.props.elementData?.content?.redactorNoOuterDiv === true
            redactorEle = (
                <Redactor
                    isLandingPage={this.props.isLandingPage}
                    campaign={this.props.campaign}
                    content={thisContent}
                    updateContent={this.updateHtmlValue}
                    defaultFont={eleProps?.style?.fontFamily || ''}
                    defaultColor={color || ''}
                    globalColours={[]}
                    favoriteColors={favoriteColors}
                    elementsData={this.props.elementsData}
                    elementUuid={elementUuid}
                    overrideTools={['bold', 'italic', 'underline']}
                    allowParagraphs={false}
                    noOuterDiv={noOuterDiv}
                    overridePlugins={[]}
                />
            )
        }

        return (
            <span {...eleProps}>
                {isSelected && redactorEle}
                {!isSelected && hasLabel && <span dangerouslySetInnerHTML={{ __html: thisContent }} />}
                {!isSelected && !hasLabel && (
                    <span style={{ display: 'inline-block', minHeight: '1.2em', minWidth: '1em' }} />
                )}
            </span>
        )
    }
}
